import { useState } from 'react';

const STORAGE_KEY = 'site-access';

const styles = {
  wrapper: {
    minHeight: '100vh',
    background: '#1E13AA',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  logo: {
    width: 'min(360px, 70vw)',
    height: 'auto',
    userSelect: 'none',
  },
};

export default function ConstructionGate({ children }) {
  const [granted] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === '1'
  );

  if (granted) return children;

  return (
    <div style={styles.wrapper}>
      <img
        src="/etsem-media-logo.png"
        alt="Etsem Media"
        style={styles.logo}
        draggable="false"
      />
    </div>
  );
}
